<template>
    <div class="btn-group">
        <button v-if="canDelete" class="btn btn-danger btn-sm" @click="confirmDeleting">
            <i class="fas fa-trash-alt"></i>
        </button>
    </div>
</template>

<script>

  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @return {boolean}
       */
      canDelete() {
        return this.row.canDelete;
      },

      /**
       * @return {string}
       */
      deleteUrl() {
        return this.row.deleteUrl;
      },
    },

    methods: {
      /**
       * @event delete
       */
      confirmDeleting() {
        this.$confirm('Are you sure you want to delete this item?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => {
          });
      },
    },
  }
</script>
